// SAFEMAT — lead-gen first. No public pricing. Tatami-first, broad verticals.
const t = {
  fr: {
    nav: {
      home: "Accueil",
      desinfection: "Désinfection",
      pourQui: "Pour qui",
      tarifs: "Devis",
      contact: "Contact",
      cta: "Devis gratuit",
    },
    locale: "FR",
    switchLang: "DE",

    hero: {
      eyebrow: "Hygiène tatami · Suisse",
      h1: "Désinfection PRO des tatamis & surfaces sportives au sol.",
      sub: "Désinfection vapeur professionnelle pour académies sportives, écoles, garderies, salles de fitness et espaces à surfaces sportives partagées.",
      cta: "Demander un devis gratuit",
      ctaSecondary: "Parler à un expert",
    },

    why: {
      eyebrow: "Pourquoi c'est important",
      title: "Pourquoi l'hygiène des surfaces compte.",
      lead: "Une surface sportive partagée concentre la sueur, le contact peau-à-peau et le passage pieds nus de dizaines de personnes chaque semaine. Sans un protocole d'hygiène sérieux, ce n'est plus un détail opérationnel — c'est un facteur de réputation et de confiance.",
      points: [
        { t: "Sueur et contact direct", d: "Heures cumulées d'entraînement et de manipulation. Les surfaces absorbent ce qui s'y dépose." },
        { t: "Odeurs et résidus", d: "Des résidus invisibles s'installent dans les fibres et finissent par se sentir, surtout les soirs de forte affluence." },
        { t: "Confiance des usagers", d: "Pratiquants, parents et responsables évaluent un établissement d'abord à son hygiène." },
        { t: "Risque de réputation", d: "Une mauvaise expérience sur les avis en ligne pèse plus lourd qu'une saison bien menée." },
      ],
      note: "Un incident d'hygiène coûte toujours plus cher que la prévention.",
    },

    what: {
      eyebrow: "Notre méthode",
      title: "Désinfection vapeur haute température, sans chimie agressive.",
      lead: "La vapeur surchauffée pénètre en profondeur dans les fibres : elle élimine les bactéries, les acariens et les allergènes incrustés, redresse les fibres écrasées et neutralise les odeurs de sueur ou de renfermé — sans recourir à des produits chimiques agressifs.",
      bullets: [
        { t: "Haute température", d: "Vapeur surchauffée appliquée en profondeur. Neutralise efficacement bactéries, acariens, spores de moisissure et allergènes incrustés dans les fibres." },
        { t: "Sans chimie agressive", d: "Action assainissante par la chaleur seule. Particulièrement adaptée aux tatamis de dojo et d'arts martiaux, où la peau est en contact direct avec la surface." },
        { t: "Odeurs neutralisées", d: "Élimine les odeurs de sueur et de renfermé. La vapeur redresse aussi les fibres écrasées et rafraîchit le matériau en profondeur." },
        { t: "Adapté aux surfaces sportives", d: "Conçu pour les tatamis synthétiques de sport et de dojo, plus résistants à la chaleur. Pour les tatamis traditionnels en paille de riz, le protocole est adapté." },
      ],
      disclaimer: "Notre service aide à réduire les risques d'hygiène et soutient le protocole sanitaire de l'établissement. Les tatamis traditionnels en paille de riz sont sensibles à l'humidité : pour ce type de surface, nous adaptons l'intervention et contrôlons strictement le séchage, en suivant les recommandations d'entretien du fabricant. L'entretien quotidien après chaque session reste de la responsabilité de l'établissement.",
    },

    verticals: {
      eyebrow: "Pour qui",
      title: "Spécialistes du tatami, présents sur toutes les surfaces sportives.",
      lead: "Nous travaillons avec tous les établissements qui dépendent d'une surface sportive ou tatami propre et fiable.",
      items: [
        "Académies sportives",
        "Salles de fitness et d'entraînement",
        "Gymnases et salles multisports",
        "Écoles",
        "Garderies et crèches",
        "Studios bien-être, yoga, pilates",
        "Centres thérapeutiques",
        "Aires de jeux et centres pour enfants",
      ],
    },

    serviceOffer: {
      eyebrow: "Devis personnalisé",
      title: "Une désinfection adaptée à votre établissement.",
      lead: "Nous définissons avec vous la fréquence idéale selon votre surface, votre activité et vos horaires : intervention ponctuelle ou passages réguliers chaque mois.",
      cardTitle: "Désinfection vapeur professionnelle",
      items: [
        "Tatamis & surfaces sportives au sol",
        "Intervention ponctuelle ou passages réguliers",
        "Fréquence définie avec vous",
        "Intervention hors heures d'activité",
        "Devis personnalisé selon la surface",
      ],
      cta: "Demander un devis gratuit",
    },

    how: {
      eyebrow: "Processus",
      title: "Comment ça marche.",
      steps: [
        { n: "01", t: "Vous demandez un devis", d: "Quelques infos sur votre établissement. Surface estimée, type, ville." },
        { n: "02", t: "Nous vous contactons", d: "Validation logistique, accès et créneaux selon votre planning." },
        { n: "03", t: "Proposition adaptée", d: "Prix et fréquence personnalisés selon votre établissement." },
        { n: "04", t: "Début des interventions", d: "Hors heures d'activité. Désinfection vapeur, séchage rapide." },
      ],
    },

    faq: {
      eyebrow: "FAQ",
      title: "Questions fréquentes.",
      items: [
        { q: "Quels contaminants la vapeur élimine-t-elle ?", a: "La très haute température neutralise efficacement les bactéries, les acariens, les spores de moisissure et les allergènes incrustés dans les fibres. La vapeur redresse également les fibres écrasées et élimine les odeurs de sueur ou de renfermé." },
        { q: "Pourquoi la vapeur plutôt qu'un produit chimique ?", a: "L'action assainissante de la vapeur surchauffée se fait sans produits chimiques agressifs — un point critique pour les tatamis de dojo et d'arts martiaux où la peau est en contact direct avec la surface. Pas de résidus, pas d'odeur chimique, pas d'irritation." },
        { q: "Vos interventions risquent-elles d'abîmer le tatami ?", a: "Les tatamis synthétiques de sport et de dojo supportent très bien la vapeur — c'est pour eux que notre service est calibré. Les tatamis traditionnels en paille de riz sont plus sensibles à l'humidité ; pour ce type de surface, nous adaptons le protocole et contrôlons strictement le séchage, en suivant les recommandations d'entretien du fabricant." },
        { q: "Est-ce que cela remplace l'entretien quotidien ?", a: "Non. L'entretien quotidien reste de la responsabilité de l'établissement. Notre intervention apporte une désinfection profonde, en complément, à un rythme régulier." },
        { q: "Désinfectez-vous les vestiaires, douches ou toilettes ?", a: "Non. Nous sommes spécialisés exclusivement dans la désinfection des surfaces tatami et sportives au sol." },
        { q: "À quelle fréquence intervenez-vous ?", a: "Nous la définissons avec vous selon votre surface, votre activité et vos horaires : intervention ponctuelle, passages réguliers chaque mois ou rythme à ajuster ensemble." },
        { q: "Une fréquence hebdomadaire est-elle possible ?", a: "Oui, si votre établissement le nécessite. Le prix et la planification sont adaptés en conséquence." },
        { q: "Garantissez-vous l'absence d'infections ?", a: "Non. Aucun prestataire sérieux ne peut le garantir. Notre service aide à réduire les risques d'hygiène et soutient le protocole de l'établissement." },
        { q: "Quand intervenez-vous ?", a: "Exclusivement en dehors des heures d'activité. Nous nous adaptons à votre planning pour ne jamais perturber l'établissement." },
        { q: "Comment obtenir un prix ?", a: "Demandez un devis gratuit. Nous validons votre surface et votre logistique avant de vous envoyer une proposition adaptée." },
        { q: "Travaillez-vous dans toute la Suisse ?", a: "Nous couvrons les principaux cantons romands et alémaniques. Contactez-nous pour confirmer notre tournée dans votre région." },
      ],
    },

    contact: {
      eyebrow: "Contact",
      title: "Parlons directement.",
      lead: "Contactez-nous par WhatsApp ou téléphone. Réponse rapide, sans formulaire intermédiaire.",
    },

    quote: {
      pageTitle: "Demander un devis gratuit",
      eyebrow: "Devis gratuit",
      title: "Parlons de votre établissement.",
      lead: "Remplissez ces quelques champs. Nous ouvrons ensuite une conversation WhatsApp avec votre demande pré-remplie pour démarrer rapidement.",
      fields: {
        establishment: "Établissement / société",
        contactName: "Nom du contact",
        email: "Email",
        phone: "Téléphone",
        city: "Ville",
        establishmentType: "Type d'établissement",
        surface: "Surface estimée (m²)",
        desiredNeed: "Besoin souhaité",
        frequencyComment: "Fréquence souhaitée / commentaire",
        message: "Message (optionnel)",
      },
      typeOptions: [
        "Académie sportive",
        "Salle fitness / entraînement",
        "Gymnase / salle multisport",
        "École",
        "Garderie / crèche",
        "Studio bien-être / yoga / pilates",
        "Centre thérapeutique",
        "Aire de jeux / activité enfant",
        "Autre",
      ],
      needOptions: [
        "Intervention ponctuelle",
        "Passages réguliers",
        "Je ne sais pas encore",
      ],
      frequencyPlaceholder: "Ex: 2 fois par mois, chaque semaine, seulement une première intervention, à définir ensemble...",
      submit: "Envoyer & ouvrir WhatsApp",
      sending: "Envoi…",
      successTitle: "Demande reçue.",
      successLead: "Nous ouvrons WhatsApp avec votre demande pré-remplie. Si rien ne s'ouvre, cliquez sur le bouton ci-dessous.",
      openWhatsApp: "Ouvrir WhatsApp",
      back: "Retour à l'accueil",
      error: "Une erreur est survenue. Vous pouvez nous contacter directement par WhatsApp.",
      waPrefix: "Bonjour,\n\nJe souhaite recevoir un devis gratuit pour une désinfection vapeur professionnelle de tatamis / surfaces sportives au sol.\n\n",
      waLabels: {
        establishment: "Établissement",
        contactName: "Nom",
        phone: "Téléphone",
        email: "Email",
        city: "Ville",
        establishmentType: "Type d'établissement",
        surface: "Surface estimée",
        desiredNeed: "Besoin souhaité",
        frequencyComment: "Fréquence / commentaire",
        message: "Message",
      },
    },

    footer: {
      tagline: "Désinfection vapeur des surfaces tatami et sportives au sol en Suisse.",
      links: "Navigation",
      legal: "Légal",
      contact: "Contact",
      legalNotice: "Mentions légales",
      privacy: "Confidentialité",
      terms: "Conditions générales",
      rights: "Tous droits réservés.",
    },

    success: {
      checking: "Vérification du paiement…",
      title: "Paiement reçu.",
      lead: "Merci. Nous revenons vers vous rapidement pour confirmer la suite de l'intervention.",
      back: "Retour à l'accueil",
    },

    cancel: {
      title: "Paiement annulé.",
      lead: "Le paiement n'a pas été finalisé. Vous pouvez demander un nouveau lien si nécessaire.",
      back: "Demander un devis",
    },
  },

  de: {
    nav: {
      home: "Startseite",
      desinfection: "Desinfektion",
      pourQui: "Für wen",
      tarifs: "Offerte",
      contact: "Kontakt",
      cta: "Gratis-Offerte",
    },
    locale: "DE",
    switchLang: "FR",

    hero: {
      eyebrow: "Tatami-Hygiene · Schweiz",
      h1: "PRO-Desinfektion von Tatamis & Sportbodenflächen.",
      sub: "Professionelle Dampfdesinfektion für Sportakademien, Schulen, Kitas, Fitnessräume und Einrichtungen mit gemeinsam genutzten Sportbodenflächen.",
      cta: "Gratis-Offerte anfragen",
      ctaSecondary: "Mit einem Experten sprechen",
    },

    why: {
      eyebrow: "Warum es zählt",
      title: "Warum Oberflächenhygiene zählt.",
      lead: "Eine gemeinsam genutzte Sportfläche sammelt Schweiss, Hautkontakt und barfuss Trainierende von Dutzenden Personen pro Woche. Ohne ein ernsthaftes Hygieneprotokoll ist das ein Reputations- und Vertrauensfaktor.",
      points: [
        { t: "Schweiss und direkter Kontakt", d: "Stunden um Stunden Training. Oberflächen nehmen alles auf." },
        { t: "Gerüche und Rückstände", d: "Unsichtbare Rückstände setzen sich in den Fasern fest und werden riechbar." },
        { t: "Vertrauen der Nutzer", d: "Trainierende, Eltern und Verantwortliche beurteilen eine Einrichtung zuerst nach der Hygiene." },
        { t: "Reputationsrisiko", d: "Eine schlechte Bewertung wiegt schwerer als eine ganze gut geführte Saison." },
      ],
      note: "Ein Hygienevorfall kostet immer mehr als Prävention.",
    },

    what: {
      eyebrow: "Unsere Methode",
      title: "Dampfdesinfektion bei hoher Temperatur — ohne aggressive Chemie.",
      lead: "Überhitzter Dampf dringt tief in die Fasern ein: Er eliminiert Bakterien, Milben und eingebettete Allergene, richtet die niedergedrückten Fasern wieder auf und neutralisiert Schweiss- und Muffgerüche — ganz ohne aggressive Chemikalien.",
      bullets: [
        { t: "Hohe Temperatur", d: "Überhitzter Dampf, tief in die Fasern angewendet. Neutralisiert wirksam Bakterien, Milben, Schimmelsporen und in den Fasern eingebettete Allergene." },
        { t: "Ohne aggressive Chemie", d: "Hygienewirkung allein durch Hitze. Besonders geeignet für Dojo-Tatamis und Kampfsportflächen, bei denen die Haut direkt mit der Oberfläche in Kontakt kommt." },
        { t: "Gerüche neutralisiert", d: "Beseitigt Schweiss- und Muffgerüche. Der Dampf richtet zudem niedergedrückte Fasern auf und frischt das Material in der Tiefe auf." },
        { t: "Für Sportflächen geeignet", d: "Konzipiert für synthetische Sport- und Dojo-Tatamis, die hitzebeständiger sind. Bei traditionellen Reisstroh-Tatamis wird das Protokoll angepasst." },
      ],
      disclaimer: "Unser Service hilft, Hygienerisiken zu senken, und unterstützt das Hygieneprotokoll der Einrichtung. Traditionelle Reisstroh-Tatamis sind feuchtigkeitsempfindlich: Für diese Oberflächen passen wir den Einsatz an und kontrollieren die Trocknung streng — stets gemäss den Pflegeempfehlungen des Herstellers. Die tägliche Pflege nach jeder Session bleibt in der Verantwortung der Einrichtung.",
    },

    verticals: {
      eyebrow: "Für wen",
      title: "Tatami-Spezialisten, präsent auf allen Sportbodenflächen.",
      lead: "Wir arbeiten mit allen Einrichtungen, die auf eine saubere und zuverlässige Sport- oder Tatami-Fläche angewiesen sind.",
      items: [
        "Sportakademien",
        "Fitness- und Trainingsräume",
        "Turnhallen und Mehrzwecksäle",
        "Schulen",
        "Kitas und Krippen",
        "Wellness-, Yoga- und Pilates-Studios",
        "Therapiezentren",
        "Spielbereiche und Kinderzentren",
      ],
    },

    serviceOffer: {
      eyebrow: "Individuelle Offerte",
      title: "Eine Desinfektion, die zu Ihrer Einrichtung passt.",
      lead: "Wir definieren die ideale Frequenz gemeinsam mit Ihnen anhand von Fläche, Aktivität und Zeitfenstern: einmaliger Einsatz oder regelmässige Einsätze pro Monat.",
      cardTitle: "Professionelle Dampfdesinfektion",
      items: [
        "Tatamis & Sportbodenflächen",
        "Einmaliger Einsatz oder regelmässige Einsätze",
        "Frequenz gemeinsam definiert",
        "Einsatz ausserhalb der Betriebszeiten",
        "Individuelle Offerte nach Fläche",
      ],
      cta: "Gratis-Offerte anfragen",
    },

    how: {
      eyebrow: "Ablauf",
      title: "So funktioniert es.",
      steps: [
        { n: "01", t: "Sie fragen eine Offerte an", d: "Wenige Angaben zu Ihrer Einrichtung. Fläche, Typ, Stadt." },
        { n: "02", t: "Wir melden uns", d: "Validierung von Logistik, Zugang und Terminen nach Ihrem Plan." },
        { n: "03", t: "Passender Vorschlag", d: "Preis und Frequenz auf Ihre Einrichtung zugeschnitten." },
        { n: "04", t: "Start der Einsätze", d: "Ausserhalb der Betriebszeiten. Dampfdesinfektion, schnelle Trocknung." },
      ],
    },

    faq: {
      eyebrow: "FAQ",
      title: "Häufige Fragen.",
      items: [
        { q: "Welche Kontaminanten beseitigt der Dampf?", a: "Die sehr hohe Temperatur neutralisiert wirksam Bakterien, Milben, Schimmelsporen und in den Fasern eingebettete Allergene. Der Dampf richtet zudem niedergedrückte Fasern auf und beseitigt Schweiss- und Muffgerüche." },
        { q: "Warum Dampf statt eines klassischen Chemieprodukts?", a: "Überhitzter Dampf desinfiziert ohne aggressive Chemikalien — entscheidend für Dojo- und Kampfsport-Tatamis, bei denen die Haut direkt mit der Oberfläche in Kontakt kommt. Keine Rückstände, kein Chemiegeruch, keine Hautreizung." },
        { q: "Können Ihre Einsätze die Tatamis beschädigen?", a: "Synthetische Sport- und Dojo-Tatamis vertragen Dampf sehr gut — dafür ist unser Service ausgelegt. Traditionelle Reisstroh-Tatamis sind feuchtigkeitsempfindlicher; für diese Oberflächen passen wir das Protokoll an und kontrollieren die Trocknung streng nach den Pflegeempfehlungen des Herstellers." },
        { q: "Ersetzt das die tägliche Pflege?", a: "Nein. Die tägliche Pflege bleibt in Verantwortung der Einrichtung. Unser Einsatz bringt eine ergänzende Tiefendesinfektion im regelmässigen Rhythmus." },
        { q: "Desinfizieren Sie Umkleiden, Duschen oder Toiletten?", a: "Nein. Wir sind ausschliesslich auf Tatami- und Sportbodenflächen spezialisiert." },
        { q: "Wie oft kommen Sie?", a: "Wir definieren die Frequenz gemeinsam anhand von Fläche, Aktivität und Zeitfenstern: einmaliger Einsatz, regelmässige Einsätze pro Monat oder ein Rhythmus, den wir zusammen festlegen." },
        { q: "Ist eine wöchentliche Frequenz möglich?", a: "Ja, wenn Ihre Einrichtung es benötigt. Preis und Planung werden entsprechend angepasst." },
        { q: "Garantieren Sie Infektionsfreiheit?", a: "Nein. Kein seriöser Dienstleister kann das garantieren. Unser Service hilft, Hygienerisiken zu senken, und unterstützt das Protokoll der Einrichtung." },
        { q: "Wann kommen Sie?", a: "Ausschliesslich ausserhalb der Betriebszeiten. Wir passen uns Ihrem Plan an." },
        { q: "Wie erhalte ich einen Preis?", a: "Fragen Sie eine Gratis-Offerte an. Wir validieren Ihre Fläche und Logistik vor dem Vorschlag." },
        { q: "Arbeiten Sie in der ganzen Schweiz?", a: "Wir decken die wichtigsten Kantone der Romandie und Deutschschweiz ab. Kontaktieren Sie uns, um die Verfügbarkeit in Ihrer Region zu prüfen." },
      ],
    },

    contact: {
      eyebrow: "Kontakt",
      title: "Sprechen wir direkt.",
      lead: "Kontaktieren Sie uns per WhatsApp oder Telefon. Schnelle Antwort, ohne Zwischenformular.",
    },

    quote: {
      pageTitle: "Gratis-Offerte anfragen",
      eyebrow: "Gratis-Offerte",
      title: "Sprechen wir über Ihre Einrichtung.",
      lead: "Füllen Sie diese Felder aus. Wir öffnen anschliessend eine WhatsApp-Konversation mit Ihrer vorgefüllten Anfrage.",
      fields: {
        establishment: "Einrichtung / Firma",
        contactName: "Name des Kontakts",
        email: "E-Mail",
        phone: "Telefon",
        city: "Stadt",
        establishmentType: "Art der Einrichtung",
        surface: "Geschätzte Fläche (m²)",
        desiredNeed: "Gewünschter Bedarf",
        frequencyComment: "Gewünschte Frequenz / Kommentar",
        message: "Nachricht (optional)",
      },
      typeOptions: [
        "Sportakademie",
        "Fitness- / Trainingsraum",
        "Turnhalle / Mehrzwecksaal",
        "Schule",
        "Kita / Krippe",
        "Wellness- / Yoga- / Pilates-Studio",
        "Therapiezentrum",
        "Spielbereich / Kinderaktivität",
        "Sonstiges",
      ],
      needOptions: [
        "Einmaliger Einsatz",
        "Regelmässige Einsätze",
        "Noch unsicher",
      ],
      frequencyPlaceholder: "Z. B. 2-mal pro Monat, jede Woche, nur ein erster Einsatz, gemeinsam definieren...",
      submit: "Senden & WhatsApp öffnen",
      sending: "Senden…",
      successTitle: "Anfrage erhalten.",
      successLead: "Wir öffnen WhatsApp mit Ihrer vorgefüllten Anfrage. Falls nichts geöffnet wird, klicken Sie unten.",
      openWhatsApp: "WhatsApp öffnen",
      back: "Zur Startseite",
      error: "Ein Fehler ist aufgetreten. Kontaktieren Sie uns direkt per WhatsApp.",
      waPrefix: "Guten Tag,\n\nIch möchte eine Gratis-Offerte für die Desinfektion von Tatami- / Sportflächen erhalten.\n\n",
      waLabels: {
        establishment: "Einrichtung",
        contactName: "Name",
        phone: "Telefon",
        email: "E-Mail",
        city: "Stadt",
        establishmentType: "Art der Einrichtung",
        surface: "Geschätzte Fläche",
        desiredNeed: "Gewünschter Bedarf",
        frequencyComment: "Frequenz / Kommentar",
        message: "Nachricht",
      },
    },

    footer: {
      tagline: "Dampfdesinfektion der Tatami- und Sportbodenflächen in der Schweiz.",
      links: "Navigation",
      legal: "Rechtliches",
      contact: "Kontakt",
      legalNotice: "Impressum",
      privacy: "Datenschutz",
      terms: "AGB",
      rights: "Alle Rechte vorbehalten.",
    },

    success: {
      checking: "Zahlung wird überprüft…",
      title: "Zahlung erhalten.",
      lead: "Danke. Wir melden uns schnell, um die nächsten Schritte zu bestätigen.",
      back: "Zur Startseite",
    },

    cancel: {
      title: "Zahlung abgebrochen.",
      lead: "Die Zahlung wurde nicht abgeschlossen. Bei Bedarf können Sie einen neuen Link anfordern.",
      back: "Offerte anfragen",
    },
  },
};

export default t;
